module.exports = __webpack_public_path__ + "img/keyboard_Minus.5d02f9db.png";